import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';
import { Check } from 'lucide-react';

const Membership = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [selectedPlan, setSelectedPlan] = React.useState('yearly');

 

  const handleStartTrial = () => {
    if (!user) {
      navigate('/register');
      return;
    }

    const selectedPlanDetails = plans[selectedPlan];
    
    navigate('/payment', { 
      state: { 
        plan: selectedPlan,
        planTitle: selectedPlanDetails.title,
        amount: selectedPlanDetails.price,
        recurring: selectedPlan === 'monthly'
      } 
    });
  };

  const plans = {
    monthly: {
      title: 'Aylık ödeme',
      price: 90,
      features: [
        'Sadece kredi kartı kullanabilirsiniz.',
        'Her ay kayıtlı kredi kartınızdan otomatik olarak çekilir.',
        'Dilediğiniz zaman iptal edebilirsiniz.',
      
      ]
    },
    yearly: {
      title: 'Yıllık ödeme',
      price: 900,
      originalPrice: 5040,
      discount: '17% indirim',
      features: [
        'Banka kartı veya kredi kartı kullanabilirsiniz.',
        'Yıl sonunda otomatik yenilenmez.',
        'Fiyat güncellemelerinden etkilenmezsiniz.',
     
      ]
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E23] text-white py-24 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-[#246BFD] mb-4">
            Smart Portföy PRO
          </h1>
          <p className="text-lg text-gray-300">
            Finansal analiz için ihtiyacınız olan her şey için{' '}
            <span className="font-semibold">tek paket, şeffaf fiyatlama.</span>
          </p>
          {user && (
            <p className="text-gray-400 mt-2">
              {user.displayName || user.email}
            </p>
          )}
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
          {/* Monthly Plan */}
          <div 
            className={`rounded-2xl p-6 cursor-pointer transition-all duration-300 ${
              selectedPlan === 'monthly' 
                ? 'bg-[#1A1D1F] border-2 border-[#246BFD]' 
                : 'bg-[#1A1D1F] border-2 border-transparent'
            }`}
            onClick={() => setSelectedPlan('monthly')}
          >
            <div className="flex items-center mb-4">
              <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                selectedPlan === 'monthly' ? 'border-[#246BFD]' : 'border-gray-600'
              }`}>
                {selectedPlan === 'monthly' && (
                  <div className="w-3 h-3 rounded-full bg-[#246BFD]" />
                )}
              </div>
              <h3 className="text-xl font-semibold">{plans.monthly.title}</h3>
            </div>
            <ul className="space-y-3 mb-6">
              {plans.monthly.features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <Check className="w-5 h-5 text-gray-400 mr-2 mt-1 flex-shrink-0" />
                  <span className="text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>
            <div className="flex items-baseline mt-4">
              <span className="text-2xl font-bold">₺</span>
              <span className="text-4xl font-bold ml-1">{plans.monthly.price}</span>
              <span className="text-gray-400 ml-2">/ ay</span>
            </div>
          </div>

          {/* Yearly Plan */}
          <div 
            className={`rounded-2xl p-6 cursor-pointer transition-all duration-300 ${
              selectedPlan === 'yearly' 
                ? 'bg-[#1A1D1F] border-2 border-[#246BFD]' 
                : 'bg-[#1A1D1F] border-2 border-transparent'
            }`}
            onClick={() => setSelectedPlan('yearly')}
          >
            <div className="flex items-center mb-4">
              <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                selectedPlan === 'yearly' ? 'border-[#246BFD]' : 'border-gray-600'
              }`}>
                {selectedPlan === 'yearly' && (
                  <div className="w-3 h-3 rounded-full bg-[#246BFD]" />
                )}
              </div>
              <h3 className="text-xl font-semibold">{plans.yearly.title}</h3>
            </div>
            <ul className="space-y-3 mb-6">
              {plans.yearly.features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <Check className="w-5 h-5 text-gray-400 mr-2 mt-1 flex-shrink-0" />
                  <span className="text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>
            <div className="flex items-baseline mt-4">
              <span className="text-2xl font-bold">₺</span>
              <div className="flex items-center">
                <span className="text-4xl font-bold ml-1">{plans.yearly.price}</span>
                <div className="ml-2">
                  <span className="line-through text-gray-500">₺{plans.yearly.originalPrice}</span>
                  <span className="ml-2 text-green-500 text-sm">{plans.yearly.discount}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <div className="text-center">
          <button
            onClick={handleStartTrial}
            className="bg-[#246BFD] text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors"
          >
            {user ? 'Ödemeye geç' : 'Üye ol ve başla'}
          </button>
          {!user && (
            <p className="text-gray-400 mt-2 text-sm">
              Devam etmek için hesap oluşturmanız gerekiyor.
            </p>
          )}
        </div>

        {/* Features Section */}
        <div className="mt-24">
          <h2 className="text-3xl font-bold text-center mb-12">
            Hangi ayrıcalıklara sahip olacaksınız?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Özet Rapor */}
            <div className="bg-[#1A1D1F] rounded-2xl p-6">
              <img 
                src="/screenshots/piechart.png" 
                alt=" portfolio" 
                className="w-full rounded-lg mb-4 border border-gray-800"
              />
              <h3 className="text-xl font-semibold mb-2">Portföy Dağılımı (Pie Chart)</h3>
              <p className="text-gray-400">
              Kullanıcıların mevcut yatırımlarının farklı kategorilere (örneğin: tahvil, nakit, emtia, hisse senedi) nasıl dağıldığını görmelerine olanak sağlar. Grafik, hedef portföy ile mevcut dağılımı karşılaştırmaya yardımcı olur ve her bir yatırım kaleminin toplam portföy içerisindeki yüzdesini net bir şekilde gösterir.
              </p>
            </div>

            {/* Webinarlar */}
            <div className="bg-[#1A1D1F] rounded-2xl p-6">
              <img 
                src="/screenshots/portfoytable.png" 
                alt="Webinarlar" 
                className="w-full rounded-lg mb-4 border border-gray-800"
              />
              <h3 className="text-xl font-semibold mb-2">Portföy Durumu (Tablo)</h3>
              <p className="text-gray-400">
              Kullanıcıya her bir varlık kategorisindeki mevcut yatırım değeri ile hedeflenen yatırım arasındaki farkı tablo biçiminde sunar. Bu tablo, varlıkların mevcut değerini, hedef yüzdesini ve bu hedefe ne kadar yakın olduğunu detaylı bir şekilde analiz etme imkânı tanır.
              </p>
            </div>

            {/* Yeni İş İlişkileri */}
            <div className="bg-[#1A1D1F] rounded-2xl p-6">
              <img 
                src="/screenshots/rebalance.png" 
                alt="Yeni İş İlişkileri" 
                className="w-full rounded-lg mb-4 border border-gray-800"
              />
              <h3 className="text-xl font-semibold mb-2">Dengeleme Önerileri (Rebalancing)</h3>
              <p className="text-gray-400">
              Portföydeki mevcut durumun hedef dağılıma uygun hale gelmesi için öneriler sunar. Her bir varlık kategorisi için yapılması gereken alım ya da satım işlemleri ayrıntılı bir şekilde gösterilir. Örneğin, hisse senetleri ya da teknoloji odaklı yatırımlar gibi alt kategorilerdeki dengeleme ihtiyaçlarını vurgular ve önerilen adımları liste halinde belirtir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;